<template>
    <v-layout row>
        <v-flex xs12 sm12>

            <!-- HEADER -->
            <v-card class="elevation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to Settings" @click="$router.push('/settings')">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-toolbar>
            </v-card>
            
            <!-- ERROR HANDLER -->
            <v-alert v-if="error" :value="true" color="error" icon="error" outline class="rounded-4">
                Error encountered. Please contact support. Error details: {{errorMessage}}
            </v-alert>  

            <!-- ATTENDANCE REMINDERS -->
            <attendance-reminder></attendance-reminder>

            <!-- EMPLOYMENT TRANSITION UPDATES -->
            <employment-transition></employment-transition>

            <!-- COMMENTS + HISTORY -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="pageQueryId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>

    </v-layout> 
</template>

<script>

export default {     
    name: 'AutomatedReminders',
    metaInfo: {
        title: 'Automated Reminders',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Automated Reminders' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
        ]
    },
    components: {
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory'),
        'attendance-reminder': () => import('@/components/AutomatedReminders/AttendanceReminder'),
        'employment-transition': () => import('@/components/AutomatedReminders/EmploymentTransition'),
    },   
    data () {
        return {
            error: false,
            errorMessage: '',
            loading: false,
            disabled: false,
        }
    },
    async created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Automation'
        })
    },
    computed: {
        pageQueryId() {
            return 'automated_reminders'
        },
        commentsData() {
            return {
                pageQueryId: this.pageQueryId,
                
                //these are used to notify other users when adding comment
                //this is for refactor. see dev tasks.
                pageItemCreatedBy: null,
                pageLink: null,
                pageKey: null,
                notificationTypeId: null,
            }
        },
    }
}
</script>